import React from 'react'

import { DateOfBirthSelect, Util } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

import { isValidDOB } from '../../../util/form-validation'

const { isOlderThan } = Util.validations
type Props = {
  name?: string
  required?: boolean
}

export const DateOfBirth = ({ name, required = true }: Props) => {
  const { getLabel } = useIntl()

  return (
    <DateOfBirthSelect
      name={name}
      label={getLabel('checkout.contact.dateofbirth')}
      errorMessage={getLabel('checkout.contact.dateofbirth.error')}
      dayPlaceholder={getLabel('checkout.contact.dateofbirth.day.placeholder')}
      monthPlaceholder={getLabel('checkout.contact.dateofbirth.month.placeholder')}
      yearPlaceholder={getLabel('checkout.contact.dateofbirth.year.placeholder')}
      validations={[isOlderThan(16), isValidDOB]}
      required={required}
    />
  )
}
